import { Box, Paper } from '@mui/material';
import React from 'react';
import { getSubtopicsProgress } from '../../utils/Quizze/getSubtopicsProgress';
import SubtopicTile from './SubtopicTile';
import UnknownSubtopic from './UnkownSubtopic';
import { useTranslation } from 'react-i18next';

export default function Quizze(props) {

    const {i18n} = useTranslation()

    const quizProgress = props.quizProgress;
    const subtopics = props.subtopics;
    const quizpart = props.quizpart;
    const quizpartId = quizpart.id;

    if (!(subtopics && quizpart)) return null;

    const subtopicsProgress = getSubtopicsProgress(subtopics, quizProgress);

    const everythingUnlocked = subtopicsProgress.length === subtopics.length;

    const findLastQuiz = () => {

        let activeSubtopic = subtopics.find(v => v.first);
        let ctr = 0;

        while(activeSubtopic) {            
            if (subtopicsProgress.length === ctr) {
                return activeSubtopic.name[i18n.language]
            }
            ctr++;
            activeSubtopic = subtopics.find(v => v.id === activeSubtopic.nextSubtopicId)
        }
        return ""
    }
    const lastQuiz = findLastQuiz();

    const renderSubtopics = () => {
        const subtopicsJS = [];

        let activeSubtopic = subtopics.find(v => v.first);

        while (activeSubtopic) {
            const quizProgressObject = quizProgress.find(value => {
                return value.subtopicId === activeSubtopic.id && value.finished
            });
            if (quizProgressObject) {
                subtopicsJS.push(
                    <SubtopicTile key={activeSubtopic.id} id={activeSubtopic.id} name={activeSubtopic.name[i18n.language]}
                        finished={quizProgressObject.finished} timesFinished={quizProgressObject.timesFinished}
                        quizpartId={quizpartId}
                    ></SubtopicTile>
                )
            } else {
                subtopicsJS.push(
                    <SubtopicTile key={activeSubtopic.id} id={activeSubtopic.id} name={activeSubtopic.name[i18n.language]}
                        finished={false} timesFinished={0} quizpartId={quizpartId}
                    ></SubtopicTile>
                )
                break;
            }
            activeSubtopic = subtopics.find(v => v.id === activeSubtopic.nextSubtopicId);
        }

        return subtopicsJS;
    }

    return(
        subtopics &&
        <Box sx={{display: "flex", justifyContent: "center"}}>
            <Paper sx={{p: 4, pb: 2, m: 2, display: "flex", flexDirection: "column", width: "14rem"}}>
                <Box sx={{display: "flex", flexDirection: "column", position: "relative", width: "100%", alignItems: "center"}}>
                    {renderSubtopics()}
                </Box>
            {
                !everythingUnlocked && 
                <UnknownSubtopic lastQuiz={lastQuiz}/>
            }
            </Paper>
        </Box>
    )
}